export default "__VITE_ASSET__Bog9Nyb$__"